import { css } from '@emotion/react';
import t from 'react-translate';
import PulseChecksSettings from './pulse-checks-settings';
import { PROGRAM_CONFIGURATION_SECTION_WIDTH } from '../../constants';

const styles = css`
  max-width: ${PROGRAM_CONFIGURATION_SECTION_WIDTH}px;
`;

const FeedbackSettings = () => (
  <div css={styles} className='mx-auto mb-8'>
    <div className='title heading-2 mb-2'>{t.MENTORING_PROGRAMS.SETTINGS.TABS.FEEDBACK_SETTINGS.TITLE()}</div>
    <div className='description text-regular mb-6'>{t.MENTORING_PROGRAMS.SETTINGS.TABS.FEEDBACK_SETTINGS.DESCRIPTION()}</div>
    <PulseChecksSettings />
  </div>
);

export default FeedbackSettings;
